import { createFileRoute } from '@tanstack/react-router'
import { TrainingProgramsSettings } from '@/features/organizations/settings/training-programs'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/training-programs/'
)({
  component: TrainingProgramsSettings,
})

